import i18n from "@/i18n";

export default [
    {
        key: 7,
        name: i18n.t('lease.reference.modal.subTypes.7')
    },
    {
        key: 9,
        name: i18n.t('lease.reference.modal.subTypes.9')
    },
    {
        key: 16,
        name: i18n.t('lease.reference.modal.subTypes.16')
    },
    {
        key: 20,
        name: i18n.t('lease.reference.modal.subTypes.20')
    },
    {
        key: 26,
        name: i18n.t('lease.reference.modal.subTypes.26')
    },
    {
        key: 28,
        name: i18n.t('lease.reference.modal.subTypes.28')
    },
    {
        key: 30,
        name: i18n.t('lease.reference.modal.subTypes.30')
    },
    {
        key: 34,
        name: i18n.t('lease.reference.modal.subTypes.34')
    },
    {
        key: 50,
        name: i18n.t('lease.reference.modal.subTypes.50')
    },
    {
        key: 52,
        name: i18n.t('lease.reference.modal.subTypes.52')
    },
    {
        key: 55,
        name: i18n.t('lease.reference.modal.subTypes.55')
    },
    {
        key: 56,
        name: i18n.t('lease.reference.modal.subTypes.56')
    },
    {
        key: 71,
        name: i18n.t('lease.reference.modal.subTypes.71')
    },
    {
        key: 73,
        name: i18n.t('lease.reference.modal.subTypes.73')
    },
    {
        key: 74,
        name: i18n.t('lease.reference.modal.subTypes.74')
    },
    {
        key: 75,
        name: i18n.t('lease.reference.modal.subTypes.75')
    },
    {
        key: 77,
        name: i18n.t('lease.reference.modal.subTypes.77')
    },
    {
        key: 85,
        name: i18n.t('lease.reference.modal.subTypes.85')
    },
    {
        key: 86,
        name: i18n.t('lease.reference.modal.subTypes.86')
    },
    {
        key: 95,
        name: i18n.t('lease.reference.modal.subTypes.95')
    },
    {
        key: 97,
        name: i18n.t('lease.reference.modal.subTypes.97')
    },
    {
        key: 102,
        name: i18n.t('lease.reference.modal.subTypes.102')
    },
    {
        key: 104,
        name: i18n.t('lease.reference.modal.subTypes.104')
    },
    {
        key: 105,
        name: i18n.t('lease.reference.modal.subTypes.105')
    },
    {
        key: 108,
        name: i18n.t('lease.reference.modal.subTypes.108')
    },
    {
        key: 109,
        name: i18n.t('lease.reference.modal.subTypes.109')
    },
    {
        key: 110,
        name: i18n.t('lease.reference.modal.subTypes.110')
    },
    {
        key: 112,
        name: i18n.t('lease.reference.modal.subTypes.112')
    },
    {
        key: 113,
        name: i18n.t('lease.reference.modal.subTypes.113')
    },
    {
        key: 114,
        name: i18n.t('lease.reference.modal.subTypes.114')
    },
    {
        key: 115,
        name: i18n.t('lease.reference.modal.subTypes.115')
    },
    {
        key: 116,
        name: i18n.t('lease.reference.modal.subTypes.116')
    },
    {
        key: 117,
        name: i18n.t('lease.reference.modal.subTypes.117')
    },
    {
        key: 118,
        name: i18n.t('lease.reference.modal.subTypes.118')
    },
    {
        key: 119,
        name: i18n.t('lease.reference.modal.subTypes.119')
    },
    {
        key: 120,
        name: i18n.t('lease.reference.modal.subTypes.120')
    },
]